import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  InputAdornment,
  Switch,
  TextField,
} from '@mui/material';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { IndicatorCategory, IndicatorsConfig } from '~/services/Http';

import { useComponent } from './useComponent';
import { useSxStyles } from './useStyles';

export interface Props {
  selectedCategory: IndicatorCategory;
  onSaved: () => void;
  onClose: () => void;
  unitId: number;
}

export const ConfigureIndicatorsDialogContent: React.FC<Props> = (props) => {
  const { t } = useTranslation();
  const sxStyles = useSxStyles();

  const {
    editableIndicators,
    handleActiveStateChange,
    handleConfigValueChange,
    saveIndicators,
  } = useComponent(props.selectedCategory, props.onSaved, props.unitId);

  return (
    <>
      <DialogContent sx={sxStyles.dialogContentRoot} data-cy="list">
        {editableIndicators.map((indicator) => (
          <Box sx={sxStyles.fieldsContainer} key={indicator.id}>
            <Switch
              checked={indicator.active}
              onChange={handleActiveStateChange(indicator.id)}
              data-cy="toggle"
            />
            <TextField
              type="number"
              label={`${t(
                `${
                  IndicatorsConfig[indicator.indicatorType]
                    .titleTranslationLabel
                }`,
              )} ${Object.values(indicator.config)[0]} ${
                IndicatorsConfig[indicator.indicatorType].unitTranslationLabel
              }`}
              fullWidth={true}
              autoFocus={true}
              margin="normal"
              value={Object.values(indicator.config)[0]}
              onChange={handleConfigValueChange(indicator.id)}
              slotProps={{
                input: {
                  endAdornment: (
                    <InputAdornment position="end">
                      {t(
                        IndicatorsConfig[indicator.indicatorType]
                          .unitTranslationLabel,
                      ).toLowerCase()}
                    </InputAdornment>
                  ),
                },
              }}
              data-cy="number"
            />
          </Box>
        ))}
      </DialogContent>

      <DialogActions>
        <Button color="primary" onClick={props.onClose}>
          {t('cancel')}
        </Button>

        <Button
          variant="contained"
          color="primary"
          onClick={saveIndicators}
          data-cy="save"
        >
          {t('save')}
        </Button>
      </DialogActions>
    </>
  );
};
